/// <amd-module name="DistributedTaskUI/Logs/AgentPhaseLogsDetailsView" />
import { IAgentPhaseJobItem } from "DistributedTaskUI/Logs/Logs.Types";
import { PhaseLogsDetailsView, IPhaseLogsDetailsViewProps } from "DistributedTaskUI/Logs/PhaseLogsDetailsView";
import { IPhaseSummaryViewProps } from "DistributedTaskUI/Logs/PhaseSummaryView";

/**
 * Details view for the agent based phase
 */
export class AgentPhaseLogsDetailsView extends PhaseLogsDetailsView<IPhaseLogsDetailsViewProps> {
    protected _getPhaseSummaryProperties(): IPhaseSummaryViewProps | null {
        const agentPhaseJobItem = this.props.item as IAgentPhaseJobItem;

        if (agentPhaseJobItem) {
            return {
                name: agentPhaseJobItem.name,
                startTime: agentPhaseJobItem.startTime,
                finishTime: agentPhaseJobItem.finishTime,
                queueTime: agentPhaseJobItem.queueTime,
                logUrl: agentPhaseJobItem.logUrl,
                agentName: agentPhaseJobItem.agentName,
                queueId: agentPhaseJobItem.queueId,
                pageContext: this.props.pageContext
            };
        } else {
            return null;
        }
    }

    protected _containerClassName: string = "agent-phase-logs-details-view";
}